
import OptimizedTableHeader from "./OptimizedTableHeader";

const TableHeader = () => {
  return <OptimizedTableHeader />;
};

export default TableHeader;
